module.exports = __webpack_public_path__ + "static/media/qrcode-lizhiweike.f2784744.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/qrcode-lizhiweike.jpg
// module id = 1993
// module chunks = 6